import type { CronListParams, CronStatus } from '../types'

export { formatChangeLogCreatedAt as formatCronChangeLogCreatedAt } from '@/lib/utils/formatChangeLogCreatedAt'

/** Strip tags / entities so table cells never render raw HTML (avoids layout breaks). */
export function cronDescriptionPlainText(html: string): string {
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

/** True when CKEditor / HTML body has no visible text (Angular required parity). */
export function isCronDescriptionEffectivelyEmpty(html: string): boolean {
  return cronDescriptionPlainText(html).length === 0
}

/** Angular list preview: first 100 chars of description + ellipsis. */
export function cronDescriptionPreview(html: string, maxLen = 100): string {
  const plain = cronDescriptionPlainText(html)
  if (!plain) return ''
  return plain.length > maxLen ? `${plain.slice(0, maxLen)}...` : plain
}

export function normalizeCronListParams(q: string, cronStatus: CronStatus | ''): CronListParams {
  const out: CronListParams = {}
  const trimmed = q.trim()
  if (trimmed) out.q = trimmed
  if (cronStatus) out.cron_status = cronStatus
  return out
}

export function cronListParamsEqual(a: CronListParams, b: CronListParams): boolean {
  const aq = a.q ?? ''
  const bq = b.q ?? ''
  const as = a.cron_status ?? ''
  const bs = b.cron_status ?? ''
  return aq === bq && as === bs
}
